export const SET_NOTIFICATION = 'SET_NOTIFICATION'

export const setNotification = ({entity, ...other}) => ({
    type: `${entity} ${SET_NOTIFICATION}`,
    meta: { ...other },
})

